export default __webpack_public_path__ + "static/media/Payment-Gateway-Header.1c910122.png";